import { FieldArray } from "formik";
import React, { useEffect, useState } from "react";

import { Button, FormControlLabel, Grid, IconButton, InputAdornment, Switch, TextField, Tooltip, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete } from '@mui/material';
import { asDate, dateRangeOverlaps } from "../../../util/date";

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    portlet: {
        'box-shadow': 'none',
    },
    formControl: {
        width: '85%',
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
    },
    autoComplete: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    button: {
        margin: theme.spacing(1)
    },
    paper: {
        marginTop: theme.spacing(2),
    },
    iconButton: {
        marginTop: theme.spacing(3),
    },
    clearButton: {
        marginTop: theme.spacing(3),
        marginLeft: '10px',
        color: 'rgba(0, 0, 0, 0.54)'
    },
    effectiveBox: {
        height: '100%',
        paddingTop: '25px'
    },
    tooltip: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        width: 400,
        border: `1px solid ${theme.palette.primary.main}`,
    },
    switch: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
}));

export default function BillingProviderNPIFieldArray({
    values, errors, setFieldValue, disabled, setFindPoviderCCNIndex
}) {

    const classes = useStyles();

    useEffect(() => {
        if(disabled) {
            handleClearFields();
        }
    }, [disabled]);

    function getError(key, index) {
        if (errors.billingProviderNpiRequest) {
            if (errors.billingProviderNpiRequest[index]) {
                return errors.billingProviderNpiRequest[index][key];
            }
            return false;
        }
        return false;
    }

    function handleBillingProviderNPIChange(e, index) {
        setFieldValue(`billingProviderNpiRequest.${index}.billingProviderNPI`, e.target.value);
        const npiRegex = /^\d{10}$/;
        if(e.target.value && npiRegex.test(e.target.value) && values.billingProviderNpiRequest[index].providerCCN === "") {
            setFindPoviderCCNIndex(index);
        }
    }

    function handleProviderCCNChange(e, index) {
        setFieldValue(`billingProviderNpiRequest.${index}.providerCCN`, e.target.value);
    }

    function handleClearFields() {
        setFieldValue(`billingProviderNpiRequest`, [{
            billingProviderNPI: '',
            providerCCN: '',
        }]);
    }

    const renderBillingProviderNpiRequest = (remove, insert) => {
        return (
            (<Grid item xs={12}>
                {values.billingProviderNpiRequest.map((npiRecord, index) =>
                    <Grid container key={index}>
                        <Grid item xs={5}>
                            <TextField
                                disabled={disabled}
                                type="text"
                                label="Billing Provider NPI"
                                name={`billingProviderNpiRequest.${index}.billingProviderNPI`}
                                className={classes.textField}
                                margin="normal"
                                value={npiRecord.billingProviderNPI}
                                onChange={e => handleBillingProviderNPIChange(e, index)}
                                helperText={getError('billingProviderNPI', index)}
                                error={getError('billingProviderNPI', index) ? true:false}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <TextField
                                disabled={disabled}
                                type="text"
                                label="Provider CCN"
                                name={`billingProviderNpiRequest.${index}.providerCCN`}
                                className={classes.textField}
                                margin="normal"
                                value={npiRecord.providerCCN}
                                onChange={e => handleProviderCCNChange(e, index)}
                                helperText={getError('providerCCN', index)}
                                error={getError('providerCCN', index)? true:false}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Grid container>
                            {(index >= 0 && values.billingProviderNpiRequest.length > 1) && (
                                <IconButton
                                    disabled={disabled}
                                    edge="start"
                                    aria-label="Delete"
                                    onClick={() => {
                                        remove(index);
                                    }}
                                    className={classes.iconButton}
                                    size="large">
                                    <DeleteIcon />
                                </IconButton>
                            )}
                            {index === 0 && (
                                <>
                                <IconButton
                                    disabled={disabled}
                                    edge="start"
                                    color="primary"
                                    aria-label="Add"
                                    onClick={() => insert(values.billingProviderNpiRequest.length, {
                                        billingProviderNPI: '',
                                        providerCCN: '',
                                    })}
                                    className={classes.iconButton}
                                    size="large">
                                    <AddCircleIcon />
                                </IconButton>
                                {/* <Button
                                    disabled={disabled}
                                    size="small"
                                    onClick={handleClearFields}
                                    className={classes.clearButton}
                                    startIcon={<DeleteIcon />}
                                >
                                    Clear All
                                </Button> */}
                                </>
                            )}
                            </Grid>
                        </Grid>

                    </Grid>
                )}
            </Grid>)
        );
    }

    return (
        <FieldArray
            name="billingProviderNpiRequest"
            render={({ remove, insert }) => (
                <Grid container>
                    {disabled ? 
                    <Tooltip
                    arrow
                    classes={{ tooltip: classes.tooltip }}
                    title={<Typography color="inherit">{'Billing Provider NPI is disabled.'}</Typography>}
                    >
                        {renderBillingProviderNpiRequest(remove, insert)}
                    </Tooltip> : renderBillingProviderNpiRequest(remove, insert) }
                </Grid>
            )}
        />
    );
}
